<template>
  <div>
    <el-form :inline="true" class="selectForm">
      <el-select
        v-model="searchForm.schoolName"
        placeholder="筛选学校信息"
        @change="selectSchool"
        clearable>
        <el-option
          v-for="item in searchForm.schoolOptions"
          :key="item"
          :value="item">
        </el-option>
      </el-select>
      <el-select
        v-model="searchForm.building"
        placeholder="筛选寝室楼信息"
        @change="selectBuilding"
        clearable>
        <el-option
          v-for="item in searchForm.buildingOptions"
          :key="item"
          :value="item">
        </el-option>
      </el-select>
      <el-select
        v-model="searchForm.room"
        placeholder="筛选寝室信息"
        @change="reloadTableData"
        clearable>
        <el-option
          v-for="item in searchForm.roomOption"
          :key="item"
          :value="item">
        </el-option>
      </el-select>
      <el-select
        v-model="searchForm.roomStatus"
        placeholder="筛选寝室状态"
        @change="reloadTableData"
        clearable>
        <el-option
          v-for="item in searchForm.roomStatusOption"
          :key="item"
          :value="item">
        </el-option>
      </el-select>
    </el-form>
    <el-table
      :data="tableData"
      border
      stripe
      v-loading="tableLoading"
      height="300px"
      element-loading-text="拼命加载中">
      <el-table-column prop="schoolName" label="学校"></el-table-column>
      <el-table-column prop="building" label="寝室楼"></el-table-column>
      <el-table-column prop="room" label="寝室号"></el-table-column>
      <el-table-column prop="genderDesc" label="性别"></el-table-column>
      <!--<el-table-column prop="number" label="人数"></el-table-column>-->
      <el-table-column prop="statusDesc" label="状态"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            type="primary"
            @click="editDormitory(scope.row)"
            size="small"
            icon="el-icon-edit">
            编辑
          </el-button>
          <el-button
            type="primary"
            @click="clickUnRent(scope.row)"
            size="small"
            icon="el-icon-edit">
            退租
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @current-change="currentChange"
      @size-change="sizeChange"
      :page-sizes="[5, 10,15, 20]"
      layout="total, sizes, prev, pager, next, jumper"
      :total=pagination.total>
    </el-pagination>

    <el-dialog
      title="编辑寝室信息"
      :visible.sync="dialogVisible"
      width="400px">
      <el-form
        :model="dialogForm"
        label-width="120px"
      >
        <el-form-item label="学校">
          <label>{{dialogForm.schoolName}}</label>
        </el-form-item>
        <el-form-item label="寝室楼">
          <label>{{dialogForm.building}}</label>
        </el-form-item>
        <el-form-item label="寝室号">
          <label>{{dialogForm.room}}</label>
        </el-form-item>
        <el-form-item label="性别">
          <el-radio-group v-model="dialogForm.gender">
            <el-radio label=0>男</el-radio>
            <el-radio label=1>女</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="人数" class="input-item">
          <el-input-number v-model="dialogForm.number"
                           :min="1"
                           :max="8"
                           size="mini">
          </el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateRoom">确 定</el-button>
      </div>
    </el-dialog>


    <el-dialog
      title="请输入退租确认码"
      :visible.sync="dialogVisible2"
      width="400px">
      <el-form
        label-width="120px"
      >
        <el-form-item label="确认码">
          <el-input v-model="dialogPassWord"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible2 = false">取 消</el-button>
        <el-button type="primary" @click="unRent(unRentRow)">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { axiosByJson, axiosByKeyValue } from '../axios/index';

export default {
  name: 'Room',
  data() {
    return {
      searchForm: {
        schoolName: '',
        building: '',
        room: '',
        roomStatus: '',
        schoolOptions: [],
        buildingOptions: [],
        roomOption: [],
        roomStatusOption: ['租赁中', '空置中'],
      },
      tableData: [],
      pagination: {
        pageNo: 1,
        pageSize: 10,
        total: 0,
      },
      tableLoading: false,
      downloadLoading: false,
      dialogVisible: false,
      dialogVisible2: false,
      dialogForm: {
        gender: '0',
        number: 1,
      },
      unRentRow: {},
      dialogPassWord: '',
    };
  },
  methods: {
    initSchoolOption() {
      axiosByJson.post('listSchool').then(({ data: { data } }) => {
        this.searchForm.schoolOptions = data;
      });
    },
    initBuildingOption() {
      axiosByKeyValue.post('listBuilding', {
        schoolName: this.searchForm.schoolName,
      }).then(({ data: { data } }) => {
        this.searchForm.buildingOptions = data;
      });
    },
    initRoomOption() {
      axiosByKeyValue.post('listRoom', {
        schoolName: this.searchForm.schoolName,
        building: this.searchForm.building,
      }).then(({ data: { data } }) => {
        this.searchForm.roomOption = data;
      });
    },
    sizeChange(pageSize) {
      this.pagination.pageSize = pageSize;
      this.reloadTableData();
    },
    currentChange(currentPage) {
      this.pagination.pageNo = currentPage;
      this.reloadTableData();
    },
    selectSchool(value) {
      this.searchForm.building = '';
      this.reloadTableData();
      if (value === '') {
        this.searchForm.buildingOptions = [];
      } else {
        this.initBuildingOption();
      }
    },
    selectBuilding(value) {
      this.searchForm.room = '';
      this.reloadTableData();
      if (value === '') {
        this.searchForm.roomOption = [];
      } else {
        this.initRoomOption();
      }
    },
    selectBuildingStatus(value) {
      this.searchForm.roomStatus = '';
      this.reloadTableData();
      if (value === '') {
        this.searchForm.roomOption = [];
      } else {
        this.initRoomOption();
      }
    },
    updateRoom() {
      axiosByJson.post('updateRoom', {
        schoolName: this.dialogForm.schoolName,
        building: this.dialogForm.building,
        room: this.dialogForm.room,
        gender: parseInt(this.dialogForm.gender, 10),
        number: this.dialogForm.number,
      }).then(() => {
        this.dialogVisible = false;
        this.$message({
          type: 'success',
          message: '操作成功',
        });
        this.reloadTableData();
      }).catch(() => {
        this.dialogVisible = false;
        this.$message({
          type: 'error',
          message: '系统异常',
        });
      });
    },
    clickUnRent(row) {
      this.unRentRow = row;
      this.dialogVisible2 = true;
    },
    unRent(row) {
      if (this.dialogPassWord !== '123') {
        this.$message({
          type: 'error',
          message: '密码错误',
        });
        return;
      }
      this.dialogVisible2 = false;
      if (row.statusDesc === '空置中') {
        this.$message({
          type: 'error',
          message: '空置寝室不允许退租',
        });
        return;
      }
      this.tableLoading = true;
      axiosByJson.post('unRent', {
        schoolName: row.schoolName,
        building: row.building,
        room: row.room,
      }).then(() => {
        this.tableLoading = false;
        this.$message({
          type: 'success',
          message: '操作成功',
        });
        this.reloadTableData();
      }).catch(() => {
        this.dialogVisible = false;
        this.$message({
          type: 'error',
          message: '系统异常',
        });
      });
    },
    reloadTableData() {
      this.tableLoading = true;
      let roomStatus = '';
      if (this.searchForm.roomStatus === '租赁中') {
        roomStatus = 'lived';
      } else if (this.searchForm.roomStatus === '空置中') {
        roomStatus = 'pending';
      } else {
        roomStatus = '';
      }
      axiosByJson.post('listAllRoomInfo', {
        pageNo: this.pagination.pageNo,
        pageSize: this.pagination.pageSize,
        schoolName: this.searchForm.schoolName,
        building: this.searchForm.building,
        room: this.searchForm.room,
        status: roomStatus,
      }).then(({ data: { data: { count, list } } }) => {
        list.forEach((val) => {
          Object.assign(val, {
            genderDesc: val.gender === 0 ? '男' : '女',
            statusDesc: val.status === 'lived' ? '租赁中' : '空置中',
          });
        });
        this.tableData = list;
        this.pagination.total = count;
        this.tableLoading = false;
      });
    },
    editDormitory(row) {
      Object.assign(this.dialogForm, row, { gender: row.gender.toString() });
      this.dialogVisible = true;
    },
  },
  created() {
    this.reloadTableData();
    this.initSchoolOption();
  },
};
</script>

<style scoped>
  .selectForm {
    text-align: center;
    margin-bottom: 15px;
  }
</style>




// WEBPACK FOOTER //
// src/components/Room.vue